import { Col, Form, Input, Row, Select, InputNumber, Button } from "antd"; 
import { useEffect, useState } from "react";

// Services Library
import { TIME } from "../../../../services/util";

// Components Library

const GeneralSetting = ({props}) => {
    const { type, form, data, readOnly } = props;

    const [value, setValue] = useState();

    useEffect(() => {
        let billingPeriod = TIME.getDayNumberFromEpoch(data?.billing_period);
        if (data){
            if (billingPeriod > 10) {
                billingPeriod = 10; 
            } 
            setValue(billingPeriod);
        }
        
    }, [form, data]);

    const handleMinus = () => {
        event.stopPropagation();
        if (value > 1  && !readOnly) {
            const newValue = value - 1;
            setValue(newValue);
            form.setFieldsValue({ billing_period: newValue });
        }
    };

    const handlePlus = () => {
        event.stopPropagation();
        if (value < 15 && !readOnly) {
            const newValue = value + 1;
            setValue(newValue);
            form.setFieldsValue({ billing_period: newValue });
        }
        else if (value == null || value == undefined) {
            setValue(1);
            form.setFieldsValue({ billing_period: 1 });
        }
    };

    const validateNumber = (_, value) => {
        if (value < 1 || value > 15) {
            return Promise.reject(new Error('Number must be between 1 and 15'));
        }
        return Promise.resolve();
    };

    const getDaySuffix = (day) => {
        if (day === 1 || day === 21 || day === 31) return "st";
        if (day === 2 || day === 22) return "nd";
        if (day === 3 || day === 23) return "rd";
        return "th";
    };

    const generateDayOptions = () => {
        const days = [
            ...Array.from({ length: 10 }, (_, i) => i + 1),
            ...Array.from({ length: 11 }, (_, i) => i + 20)
        ];
        return days.map(day => (
            <Select.Option key={day} value={`${day} of the month`}>
                {`${day}${getDaySuffix(day)} of the month`}
            </Select.Option>
        ));
    };

    return (
        <>
            { type === "Revise" ? (
                <></>
            ) : (
                <>
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px", marginTop: "10px" }}>
                    <Form.Item>
                        <Row
                        style={{
                            color: "#cacaca",
                            alignItems: "center",
                            fontSize: "15px",
                        }}
                        >
                        <Col
                            span={22}
                            style={{ textAlign: "left", width: "100%" }}
                        >
                            General Setting
                        </Col>
                        </Row>
                    </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                        <label htmlFor="company" className="labelInput">
                            Payroll processing start date<span style={{ color: "red" }}>*</span>
                        </label>
                        <Form.Item
                        name="billing_date"
                        rules={[
                            {
                            required: true,
                            message: "Payroll processing start date is required",
                            },
                        ]}
                        >
                            <Select
                                suffixIcon={
                                    <span style={{ color: "#0E2483", fontSize: "16px" }}>
                                    Select
                                    </span>
                                  }
                                placeholder="Select a date"
                                style={{ width: "100%", height: "3rem", alignItems: "center" }}
                                //value={data.billing_date}
                                disabled = { readOnly }
                            >
                                {generateDayOptions()}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <label htmlFor="company" className="labelInput">
                        Payroll processing period <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                        name="billing_period"
                        rules={[
                        {
                            required: true,
                            message: "Payroll processing period is required",
                        },
                        {
                            validator: validateNumber,
                        }
                        ]}
                    >
                        <div style={{ display: "flex", justifyContent: "center", flexDirection: "row", alignItems: "center" }}>
                            <Button style={{ width: "3rem", height: "3rem", marginRight: "-4px", backgroundColor: "white", border: "1px solid grey" ,borderColor: "#C1CEEC" }} 
                            onClick={handleMinus}>-</Button>
                            <InputNumber
                                style={{ width: "100%", height: "3rem" }}
                                className="inputForm"
                                placeholder="1-15 Days"
                                value={value}
                                min={1}
                                max={15}
                                onChange={(newValue) => {
                                    setValue(newValue);
                                    form.setFieldsValue({ billing_period: newValue });
                                }}
                                readOnly = { readOnly }
                            />
                            <Button style={{ width: "3rem", height: "3rem", backgroundColor: "white", border: "1px solid grey" ,borderColor: "#C1CEEC" }} 
                            onClick={handlePlus}>+</Button>
                        </div>
                    </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        GL Code
                    </label>
                    <Form.Item
                        name="glcode"
                    >
                        <Input className="inputForm" placeholder="For deduction from employee's salary"/>
                    </Form.Item>
                    </Col>
                </Row>
                </>
            )}
        </>
    )
}

export default GeneralSetting;